import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";

export default function Nav({ renderLibrary, setRenderLibrary }) {
  return (
    <div className="top-24 invisible md:visible font-varela right-0 z-20 dark:bg-[#0d0f17] bg-[#fce168] dark:text-[#FFFFFF] text-[#0d0f17] grow absolute text-center text-2xl overflow-hidden p-4 pl-6 rounded-l-full">
      {renderLibrary ? (
        <FontAwesomeIcon
          icon={faXmark}
          onClick={() => setRenderLibrary(!renderLibrary)}
          className="cursor-pointer"
        />
      ) : (
        <button
          className="cursor-pointer "
          onClick={() => setRenderLibrary(!renderLibrary)}
        >
          Library
        </button>
      )}
    </div>
  );
}
